import React from 'react'
import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { ColoredBar } from '../ColoredBar/ColoredBar'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hpBarColorBg: {
      backgroundColor: '#f5adad',
    },
    hpBarColor: {
      backgroundColor: '#d23232',
    },
  })
)

interface Props {
  value: number
  valueMax: number
  editable?: boolean
  onEdit?: (value: string) => void
}

export const HpBar: React.FC<Props> = ({ value, valueMax, editable, onEdit }) => {
  const classes = useStyles()
  return (
    <ColoredBar
      onEdit={onEdit}
      editable={editable}
      color={classes.hpBarColor}
      bgColor={classes.hpBarColorBg}
      title={'Życie'}
      value={value}
      valueMax={valueMax}
    />
  )
}
